export const installationPendStatus = {
	OPEN: "open",
	RESPONSE_SUBMITTED: "response_submitted",
	REOPEN: "reopen",
	CLOSED: "closed",
};
// TODO: Use enum PendStatuses
export function getInstallationPendStatusName(type) {
	let name = "";
	switch (type) {
		case installationPendStatus.OPEN:
			name = "Open";
			break;
		case installationPendStatus.RESPONSE_SUBMITTED:
			name = "Response submitted";
			break;
		case installationPendStatus.REOPEN:
			name = "Reopen";
			break;
		case installationPendStatus.CLOSED:
			name = "Closed";
			break;
		default:
			break;
	}
	return name;
}
